import { render, staticRenderFns } from "./PscsNoficationDevelopment.vue?vue&type=template&id=a827dfde"
import script from "./PscsNoficationDevelopment.vue?vue&type=script&lang=js"
export * from "./PscsNoficationDevelopment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports